import { render, staticRenderFns } from "./WesternMedicineCdss_test.vue?vue&type=template&id=778edbcc&scoped=true&"
import script from "./WesternMedicineCdss_test.vue?vue&type=script&lang=js&"
export * from "./WesternMedicineCdss_test.vue?vue&type=script&lang=js&"
import style0 from "./WesternMedicineCdss_test.vue?vue&type=style&index=0&id=778edbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778edbcc",
  null
  
)

export default component.exports